/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {BannerAdsInner} from './BannerAdsInner';

/**
 * The BannerAds model module.
 * @module model/BannerAds
 * @version v1
 */
export class BannerAds extends Array {
  /**
   * Constructs a new <code>BannerAds</code>.
   * @alias module:model/BannerAds
   * @class
   * @extends Array
   */
  constructor() {
    super();
  }

  /**
   * Constructs a <code>BannerAds</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/BannerAds} obj Optional instance to populate.
   * @return {module:model/BannerAds} The populated <code>BannerAds</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new BannerAds();
      ApiClient.constructFromObject(data, obj, 'BannerAdsInner');
    }
    return obj;
  }
}
